import { rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';

enum IncreDecreBookValSet {
  beginTerm = '1',
  beginTermEndFirstHalf = '2',
  endQuarter = '3',
  endPreviousMonth = '4',
  endMonth = '5',
}

const increDecreBookValSetMap = new Map([
  ['1', IncreDecreBookValSet.beginTerm],
  ['2', IncreDecreBookValSet.beginTermEndFirstHalf],
  ['3', IncreDecreBookValSet.endQuarter],
  ['4', IncreDecreBookValSet.endPreviousMonth],
  ['5', IncreDecreBookValSet.endMonth],
]);

function rawValueToIncreDecreBookValSet(rawValue: string) {
  return rawValueToEnumWithDefault(increDecreBookValSetMap, '')(rawValue);
}

export { IncreDecreBookValSet, increDecreBookValSetMap, rawValueToIncreDecreBookValSet };
